import { useMutation } from '@tanstack/react-query';

import type { CandidateStatus } from 'services/candidates';
import type { ICandidate } from 'types/candidate';

import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { isAxiosError } from 'helpers/clientHelpers';
import { EventBus } from 'services/event-bus/EventBus';
import { CandidateEvent } from 'services/event-bus/EventBus.types';

type UnlockCandidateParams = {
  campaignId: string | number;
  esPersonId: string;
  status: CandidateStatus;
  isUnlocked: boolean;
  reason: ICandidate.UnlockReason;
};

export const useUnlockCandidateMutation = () => {
  return useMutation(
    async (params: UnlockCandidateParams) => {
      try {
        const { data: updatedCandidate } = await campaignsClient.createOrUpdateCampaignCandidate({
          campaignId: params.campaignId,
          esPersonId: params.esPersonId,
          status: params.status,
          ...(params.isUnlocked ? {} : { is_unlocked: true, reason: params.reason }),
        });

        return updatedCandidate;
      } catch (e) {
        if (
          isAxiosError<{ status: string }>(e) &&
          e.response &&
          e.response.status === 400 &&
          e.response.data.status === "This candidate was already matched and can't have his status changed"
        ) {
          return null;
        }

        throw e;
      }
    },
    {
      onSuccess: (_, { esPersonId, reason, campaignId }) => {
        EventBus.emit(CandidateEvent.Unlocked, { esPersonId: esPersonId, reason, campaignId });
      },
    },
  );
};
